/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Strength_Level_AthleteInputs */

const en_strength_level_athlete = /** @type {(inputs: Strength_Level_AthleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Athlete`)
};

const pl_strength_level_athlete = /** @type {(inputs: Strength_Level_AthleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atleta`)
};

/**
* | output |
* | --- |
* | "Athlete" |
*
* @param {Strength_Level_AthleteInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const strength_level_athlete = /** @type {((inputs?: Strength_Level_AthleteInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Strength_Level_AthleteInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_strength_level_athlete(inputs)
	return en_strength_level_athlete(inputs)
});